import React, { PropsWithChildren } from 'react';

import dynamic from 'next/dynamic';

import { queryClient } from '@repo/transport/queries';
import { QueryClientProvider } from '@tanstack/react-query';

// Dynamically import ReactQueryDevtools (only on the client)
const ReactQueryDevtools = dynamic(
  () =>
    import('@tanstack/react-query-devtools').then(
      (mod) => mod.ReactQueryDevtools
    ),
  { ssr: false } // Disable SSR
);

const QueryClientWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {typeof window !== 'undefined' &&
        !(window.Cypress || window.isPlaywright) && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
    </QueryClientProvider>
  );
};

export default QueryClientWrapper;
